// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition24Circle: FC<Recognition24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0Zm0 5.355a8.2 8.2 0 0 0-8.2 8.2c0 1.915.658 3.674 1.757 5.069l-2.73 4.73 4.217.579 2.61 3.363L16 23.23l2.347 4.065 2.61-3.363 4.217-.578-2.732-4.73a8.162 8.162 0 0 0 1.758-5.07 8.2 8.2 0 0 0-8.2-8.2Zm-4.97 14.72a8.156 8.156 0 0 0 3.581 1.56l-1.203 2.084-1.284-1.657-2.078-.285.983-1.702Zm10.924 1.701-2.077.287-1.286 1.656-1.203-2.083a8.155 8.155 0 0 0 3.583-1.562l.983 1.702ZM16 7.356a6.2 6.2 0 1 1 0 12.4 6.2 6.2 0 0 1 0-12.4Zm-1.082 7.097-1.828-1.828-1.414 1.415 3.242 3.242 5.196-5.196-1.414-1.414-3.782 3.781Z" />
        </svg>
    );
};

export default Recognition24Circle;
